import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

import KBIntentTable from "./KBIntentTable";
import KBFlowTable from "./KBFlowTable";
import KBStepsTable from "./KBStepsTable";
import KBOptionsTable from "./KBOptionsTable";

const KnowledgeBase = () => {

    const navigate = useNavigate();

    // const [activeTab, setActiveTab] = useState("intent");

    const defaultTab = "intent";

    // initialize from localStorage
    const [activeTab, setActiveTab] = useState(() => {
        return localStorage.getItem("kb_active_tab") || defaultTab;
    });

    // persist whenever it changes
    useEffect(() => {
        localStorage.setItem("kb_active_tab", activeTab);
    }, [activeTab]);

    const handleTabChange = (k) => {
        if (k) setActiveTab(k);
    };

    return (
        <div>

            {/* Page Header */}
            <div className="page-header">
                <div className="page-header-left d-flex align-items-center">

                    <ul className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                            Knowledge Base
                        </li>

                        <li className="breadcrumb-item active">
                            KB Management
                        </li>
                    </ul>

                </div>
            </div>

            {/* Main Content */}
            <div className="main-content">

                <div className="row">

                    <div className="p-6">

                        {/* Top Header */}
                        <div className="d-flex justify-content-between align-items-center mb-4">

                            <div className="d-flex align-items-center gap-3">
                                <div>
                                    <h3 className="h4 mb-1 drawer-header">
                                        Knowledge Base Management
                                    </h3>
                                    <p className="mb-0 text-muted">
                                        Manage KB Intent, Flow, Steps and Options
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Main Card */}
                        <div className="card border-0 shadow-sm kb-main-card">

                            {/* Card Body */}
                            <div className="card-body">

                                <Tabs
                                    activeKey={activeTab}
                                    onSelect={handleTabChange}
                                    className="kb-custom-tabs mb-4"
                                >

                                    {/* KB Intent */}
                                    <Tab eventKey="intent" title="KB Intent">
                                        <KBIntentTable />
                                    </Tab>

                                    {/* KB Flow */}
                                    <Tab eventKey="flow" title="KB Flow">
                                        <KBFlowTable />
                                    </Tab>

                                    {/* KB Steps */}
                                    <Tab eventKey="steps" title="KB Steps">
                                        <KBStepsTable />
                                    </Tab>

                                    {/* KB Options */}
                                    <Tab eventKey="options" title="KB Options">
                                        <KBOptionsTable />
                                    </Tab>

                                </Tabs>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
};

export default KnowledgeBase;